import BaseService from '@/services-ts/BaseService'
import type { ICompanySettings } from '@/types/Data'
import type { IPayloadCompanySetting } from '@/types/Request'

export default class PositionServices extends BaseService {
  GetPositionList() {
    return this.GET<ICompanySettings[]>(this.PATHS.GET_POSITION_LIST)
  }

  CreatePosition(Name: string) {
    return this.POST<ICompanySettings>(this.PATHS.CREATE_POSITION, { Name })
  }

  UpdatePosition(payload: IPayloadCompanySetting) {
    return this.POST<ICompanySettings>(this.PATHS.UPDATE_POSITION, payload)
  }

  DeletePosition(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_POSITION, { Id })
  }
}
